import FindRepDataContainer from "./find-a-rep-data-container";

const FindRepQueryContainer = () => {
  return <FindRepDataContainer />;
};

export default FindRepQueryContainer;
